(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["side-navigation"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    // Retrieve the back button element by its ID
    var backButton = document.getElementById('backButton');

    // Check if the back button element exists
    if (backButton) {
        // Check if the page is the home page and there is no history
        if (window.location.pathname === '/') {
            // If on the home page with no history, make the button non-clickable
            backButton.style.pointerEvents = 'none';
            backButton.style.opacity = '0.5'; // Optionally reduce opacity to indicate it's disabled
        } else {
            // Attach a click event listener to the back button
            backButton.addEventListener('click', function (event) {
                // Prevent the default behavior of the link
                event.preventDefault();

                // Log a message to the console (optional, for debugging)
                console.log('Back button clicked');

                // Check if the previous URL is within the same domain
                if (document.referrer.indexOf(window.location.origin) !== -1) {
                    // Use history.go(-1) to navigate to the previous page
                    history.go(-1);
                } else {
                    // If the previous URL is from a different domain, navigate to the home page
                    window.location.href = '/';
                }
            });
        }
    }
});

  var homeButton = document.getElementById('homeButton');
  if (homeButton) {
        // Check if the page is the home page and there is no history
        if (window.location.pathname === '/') {
            // If on the home page with no history, make the button non-clickable
            homeButton.style.pointerEvents = 'none';
            homeButton.style.opacity = '0.5'; // Optionally reduce opacity to indicate it's disabled
        }
  }

  } catch(e) { console.error(e); }
})();
})();
